export const isValidBase64=(base64)=>{
    const regex = /^[A-Za-z0-9+/=]+$/;
    return regex.test(base64);
}
  
export const base64ToFile=(base64, fileName)=> {
    const byteString = atob(base64);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
    }
    // Create a Blob object (default MIME type will be used: "application/octet-stream")
    const blob = new Blob([byteArray]);
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob); // Generate an object URL for the Blob
    link.download = fileName; // Set the desired file name
    document.body.appendChild(link); // Append the link to the document body
    link.click(); // Trigger the download
    document.body.removeChild(link); // Clean up by removing the link
}